import { Box, styled } from '@mui/material';

const StyledBox = styled(Box)(({ theme }) => ({
  '& .DHWidgetAndFlashContainer': {
    borderRadius: theme.spacing(1),
    border: `1px solid ${theme.palette.divider[7]}`,
    background: theme.palette.secondary.main,
  },
  '& .DHWidgetContainer': {
    padding: theme.spacing(0, 1.5, 3, 1.5),
  
  },
  '& .DWSFlashsaleContainer': {
    borderBottom: `1px solid ${theme.palette.divider[7]}`,
  },
}));
export default StyledBox;
